<template>
  <div class="space-y-4 p-4 border rounded-md shadow-sm">
      <h4 class="text-md font-semibold mb-2 text-center">Add Insured Person Details</h4>
      <div class="form-grid-2">
        <div class="form-field">
            <label
            :for="`add-insured-fname-${_uid}`"
            class="block text-responsive-sm font-semibold text-gray-700 mb-1"
            >First Name <span class="text-red-500">*</span></label
            >
            <input
            :value="modelValue.firstName"
            @input="updateDetail('firstName', $event.target.value)"
            type="text"
            :id="`add-insured-fname-${_uid}`"
            class="input-responsive"
            aria-describedby="add-insured-fname-error"
            />
            <p v-if="errors.firstName" :id="`add-insured-fname-error`" class="error-message">
                {{ errors.firstName }}
            </p>
        </div>
        <div class="form-field">
            <label
            :for="`add-insured-lname-${_uid}`"
            class="block text-responsive-sm font-semibold text-gray-700 mb-1"
            >Last Name <span class="text-red-500">*</span></label
            >
            <input
            :value="modelValue.lastName"
            @input="updateDetail('lastName', $event.target.value)"
            type="text"
            :id="`add-insured-lname-${_uid}`"
            class="input-responsive"
            aria-describedby="add-insured-lname-error"
            />
            <p v-if="errors.lastName" :id="`add-insured-lname-error`" class="error-message">
                {{ errors.lastName }}
            </p>
        </div>
        <!-- Add other relevant fields if needed, e.g., DOB, Relationship -->
      </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, getCurrentInstance, watch } from 'vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// Get unique ID for labels/inputs
const instance = getCurrentInstance();
const _uid = instance ? instance.uid : Math.random().toString(36).substring(7);

const props = defineProps({
  modelValue: { 
    type: Object,
    required: true,
    default: () => ({ 
      firstName: '', 
      lastName: '' 
      // Initialize other fields if added
    }) 
  }
});

const emit = defineEmits(['update:modelValue']);

// --- Internal Validation Setup ---
const validationSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  // Add validation for other fields if added
});

const { errors, validate: validateInternally, setValues } = useForm({
  validationSchema: validationSchema,
  initialValues: props.modelValue
});

// Watch prop changes
watch(() => props.modelValue, (newValue) => {
  setValues(newValue);
}, { deep: true });

const updateDetail = (key, value) => {
  const newValue = { 
    ...props.modelValue, 
    [key]: value 
  };
  emit('update:modelValue', newValue);
};

// --- Expose validation function to parent ---
defineExpose({
  async validate() {
    setValues(props.modelValue); 
    const { valid } = await validateInternally({ force: true });
    // console.log('AddInsuredSection validation result:', valid, errors.value);
    return valid;
  }
});
</script>

<style scoped>
.input-responsive {
    @apply mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm;
}
.form-grid-2 {
    @apply grid grid-cols-1 md:grid-cols-2 gap-4;
}
.form-field {
   /* Style form fields if needed */
}
.error-message {
    @apply text-red-500 text-xs italic mt-1;
}
</style> 